import { render, staticRenderFns } from "./hotelList.vue?vue&type=template&id=b6441608&scoped=true&"
import script from "./hotelList.vue?vue&type=script&lang=js&"
export * from "./hotelList.vue?vue&type=script&lang=js&"
import style0 from "./hotelList.vue?vue&type=style&index=0&id=b6441608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6441608",
  null
  
)

export default component.exports